import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme, Typography } from '@mui/material';
import { lightTheme } from '../../common/themes';
import errorMoshUrl from '../../assets/images/error-mosh.gif';
import { ReactComponent as Logo } from '../../assets/icons/ox-built-in.svg';
import { useMaintenance } from '../hooks/use-maintenance';
import { format } from 'date-fns';

const MaintenanceShield: FC<React.PropsWithChildren> = ({ children }) => {
  const { classes } = useStyles();
  const { state } = useMaintenance();
  const { appBlocked, info } = state;

  if (appBlocked) {
    return (
      <div className={classes.underconstruction}>
        <div className={classes.container}>
          <div className={classes.paper}>
            <div className={classes.imageContainer}>
              <img
                src={errorMoshUrl}
                alt='Error Mosh animation'
                className={classes.image}
              />
            </div>
            <Logo className={classes.icon} />
            <Typography className={classes.text} variant='body1'>
              We apologize for the inconvenience, our app is undergoing
              maintenance.
              <br />
              From{' '}
              <b>
                {info?.start && (
                  <>
                    {format(new Date(info?.start), 'EEEE')}&nbsp;(
                    {info?.start.toLocaleString()})
                  </>
                )}
              </b>
              &nbsp;to&nbsp;
              <b>
                {info?.end && (
                  <>
                    {format(new Date(info?.end), 'EEEE')}&nbsp;(
                    {info?.end.toLocaleString()})
                  </>
                )}
              </b>
            </Typography>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

const useStyles = makeStyles()((theme: Theme) => ({
  underconstruction: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: theme.zIndex.tooltip,
    background: lightTheme.palette.background.default,
    padding: theme.spacing(6),
    minHeight: 500,
  },
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  paper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    background: lightTheme.palette.background.paper,
  },
  icon: {
    flex: '0 1 3rem',
  },
  text: {
    fontSize: '1rem',
    color: lightTheme.palette.text.primary,
    '& b': {
      fontWeight: 600,
    },
  },
  image: {
    width: 'auto',
    height: '100%',
  },
  imageContainer: {
    flex: '0 1 auto',
    overflow: 'hidden',
  },
}));

export default MaintenanceShield;
